import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/kodiaq/safety",
  "description": "Системы безопасности обновленного ŠKODA KODIAQ 2023. Подробный обзор автомобиля, фото, технические характеристики, комплектации  на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Kodiaq Safety",
  "name": "kodiaq-safety",
  "title": "Системы безопасности обновленного ŠKODA KODIAQ 2023/2022 | До 9 подушек безопасности в Шкода Кодиак - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const QueriedGallery = makeShortcode("QueriedGallery");
const ListMobileSlider = makeShortcode("ListMobileSlider");
const SlideIcon = makeShortcode("SlideIcon");
const Slider = makeShortcode("Slider");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="left" horizontalAlign="left" src="/m/kodiaq-2021-safety-banner1.jpg" mobileSrc="/m/kodiaq-2021-safety-banner-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading"> НА ПОДСТРАХОВКЕ </SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> Электронные ассистенты </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Ассистенты водителя, предлагаемые для ŠKODA KODIAQ, облегчают процесс
    управления и снижают риск ДТП. Ультразвуковые датчики, следящие за
    обстановкой непосредственно вокруг машины, а также радары и камеры,
    способные разглядеть опасность на расстоянии десятков и сотен метров, готовы
    днём и ночью помогать человеку за рулём.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="kodiaq-fl-safety-slider-one" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <ShowRoomTextBlock desktopPic="/m/kodiaq-2021-comfort-headlights.jpg" mobilePic="/m/kodiaq-2021-comfort-headlights-mob.jpg" model="kodiaq" mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle"> СВЕТОДИОДНЫЕ ФАРЫ </ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
    Любой обновлённый ŠKODA KODIAQ получает яркие и экономичные светодиодные
    фары, а на иллюстрации показано, как работают светодиодные матричные фары,
    которые предлагаются за доплату или как часть высших уровней комплектации. В
    автоматическом режиме дальнего света, который с такими фарами может быть
    активен всегда, компьютер, получающий данные с камеры под ветровым стеклом,
    изменяет работу определённых светодиодов, чтобы не слепить водителей
    встречного и попутного транспорта. Матричный принцип позволяет погружать в
    тень сразу несколько объектов, включая дорожные знаки, отражённый свет
    которых слишком ярок для самого водителя ŠKODA KODIAQ.
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>
    <DefaultPaddedSection mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> КРАЙНЕЕ СРЕДСТВО </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    К сожалению, ДТП всё ещё неизбежны, хотя бы потому, что даже самый
    внимательный и аккуратный водитель на очень хорошем автомобиле не может
    отвечать за остальных участников движения. На случай серьёзных столкновений
    в KODIAQ устанавливается до девяти подушек безопасности, а кузов машины
    сделан с широким применением различных видов высокопрочной стали. Очень
    рассчитываем, что вам эта информация не пригодится на практике, но сообщим:
    по результатам независимых краш-тестов модель получила высший балл, пять
    звёзд Euro NCAP.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="4" type="modal" tags="kodiaq-fl-2021-safetypage" mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Другие средства обеспечения безопасности
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Когда речь заходит о безопасности, ŠKODA KODIAQ не знает компромиссов.
    Помимо уже описанных систем безопасности, в составе стандартной комплектации
    или в качестве опции для модели KODIAQ доступны следующие решения:
  </DefaultSectionText>
  <ListMobileSlider mdxType="ListMobileSlider">
    <SlideIcon icon="/m/icon-check.svg" title="ABS" size="small" text="Предотвращает блокировку колес при экстренном торможении или при торможении на скользких поверхностях." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Тормозной ассистент" size="small" text="Помогает водителю в ситуациях, требующих аварийной остановки. Это приводит к значительному сокращению тормозного пути." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="MSR" size="small" text="Препятствует блокировке ведущих колес на ровной дороге, если водитель резко отпускает педаль акселератора." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="ASR" size="small" text="Обеспечивает плавное трогание с места и разгон без пробуксовки колес на скользких поверхностях." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="EDL" size="small" text="Преимущества системы наиболее очевидны в случае ускорения или движения в гору при пониженном сцеплении одного из ведущих колес." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="XDS+" size="small" text="Помогает водителю при резких поворотах и позволяет автомобилю сохранять заданное направление во время их динамичного прохождения." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Контроль давления в шинах" size="small" text="Система постоянно информирует водителя о давлении в шинах." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Трогания на подъеме" size="small" text="Ассистент помогает безопасно начать движение в гору. Система включается автоматически на уклоне крутизной от 5 градусов и обеспечивает легкое и безопасное трогание с места." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Мигающие стоп-сигналы" size="small" text="Уменьшают риск наезда сзади, особенно при приближении к дорожным заторам на шоссе или при резком торможении перед внезапно появившимся препятствием." contentMaxWidth="300px" mdxType="SlideIcon" />
  </ListMobileSlider>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      